import React from "react";
import styled from "styled-components";
import { Configuration, PitchPalette } from "../../context/ConfigurationContext";
import { useConnection } from "../../context/ConnectionContext";
import { Pitch } from "../../types/StrikeZone";
import { getCorrectPalette } from "../../util/CanvasUtil";
import { ConfigurationRenderProps } from "../StrikeZoneRender";

type StyleProps = {
  color: string;
  scale: number;
};

const Container = styled.div<StyleProps>`
  width: 100%;
  text-align: center;
  background: ${(props) => props.color};
  color: white;
  font-family: "TeleNeo", sans-serif !important;
  font-size: ${(props) => 4.5 * props.scale + "rem"};
  font-weight: bold;
  border-bottom: 3px solid #000000;
`;

const getColor = (config: Configuration, pitch: Pitch) => {
  const palette: PitchPalette = getCorrectPalette(config, pitch);
  return palette.header;
};

const getText = (pitch: Pitch) => {
  const { isStrike, inPlay } = pitch;
  if (inPlay) {
    return "IN PLAY";
  }
  return isStrike ? "STRIKE" : "BALL";
};

const PitchCall: React.FC<ConfigurationRenderProps> = ({ config }) => {
  const { pitch } = useConnection();
  if (!!pitch) {
    const color = getColor(config, pitch);
    const text = getText(pitch);
    return (
      <Container color={color} scale={config.scaling.multiplier}>
        {text}
      </Container>
    );
  } else {
    return <div />;
  }
};

export default PitchCall;
